(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.stations = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             ""    			: "listStations"
            ,"live"    		: "listStations"
            ,"station/:id" 	: "showStation"
			/** 
			 * If you add a station, add a redirect for it to the htaccess file so that
			 *  `/:stationName` points to what is used here, `/station/:stationName` 
			 **/
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        listStations:function(){
            APPS.stations.list.show();
        }
        ,showStation:function(id){
	        var options = {};
	        if(id === "TVKIDS" || id==="VATVCLASSROOM" || id==="TV15" || id==="TVWORLD" || id==="TVCREATE" || id==="TVFNX" || id === "NHK") {
		       options.type = "tv";
	        } else {
		        options.type = "radio"
	        }
	        options.id = id;
            APPS.stations.show.show(options);
        }
    }
    
    /*================================================================================
		Radio - Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('stations').reply("station",function(id){
        Backbone.history.navigate('/station/'+id)
        if(typeof ga != "undefined"){ ga('set','page','/station/'+id); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/station/'+id, 'page_location': window.location.origin+'/station/'+id }); }
        API.showStation(id);
    })
    
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();